// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3GIGt","title":"Info_title__1excN","links":"Info_links__2TP0S","link":"Info_link__TDj0g","logo":"Info_logo__3W43c"};